function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { LinkParagraph } from "../../../../utils/helpers";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
function Description(_ref) {
  var _config$deals, _config$deals2, _config$deals3, _config$deals4;
  var content = _ref.content,
    isRewards = _ref.isRewards,
    title = _ref.title,
    removeTopMargin = _ref.removeTopMargin,
    config = _ref.config;
  var _useState = useState((content === null || content === void 0 ? void 0 : content.split(" ").length) <= 70),
    _useState2 = _slicedToArray(_useState, 2),
    showFullSpecification = _useState2[0],
    setShowFullSpecification = _useState2[1];
  var toggleSpecification = function toggleSpecification() {
    setShowFullSpecification(function (prev) {
      return !prev;
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "mt-4",
    children: [isRewards && /*#__PURE__*/_jsx("h1", {
      className: "font-bold text-base",
      children: title
    }), content && isHTML(content) && /*#__PURE__*/_jsx("div", {
      style: {
        whiteSpace: "pre-line",
        overflowWrap: "anywhere",
        wordBreak: "break-word"
      },
      className: "\n".concat(config !== null && config !== void 0 && (_config$deals = config.deals) !== null && _config$deals !== void 0 && (_config$deals = _config$deals.dealsSection) !== null && _config$deals !== void 0 && _config$deals.subAdditionalTextClass ? config === null || config === void 0 || (_config$deals2 = config.deals) === null || _config$deals2 === void 0 || (_config$deals2 = _config$deals2.dealsSection) === null || _config$deals2 === void 0 ? void 0 : _config$deals2.subAdditionalTextClass : "", " z-10 2xl:pr-10 text-sm  ").concat(isRewards ? "mt-4 lg:mt-2 xl:mt-2" : "mt-0", " ") // html-default-styles
      ,
      dangerouslySetInnerHTML: {
        __html: showFullSpecification ? content : content.split(" ").slice(0, 50).join(" ")
      }
    }), content && !isHTML(content) && /*#__PURE__*/_jsx("div", {
      style: {
        whiteSpace: "pre-line",
        overflowWrap: "anywhere",
        wordBreak: "break-word"
      },
      className: "\n".concat(config !== null && config !== void 0 && (_config$deals3 = config.deals) !== null && _config$deals3 !== void 0 && (_config$deals3 = _config$deals3.dealsSection) !== null && _config$deals3 !== void 0 && _config$deals3.subAdditionalTextClass ? config === null || config === void 0 || (_config$deals4 = config.deals) === null || _config$deals4 === void 0 || (_config$deals4 = _config$deals4.dealsSection) === null || _config$deals4 === void 0 ? void 0 : _config$deals4.subAdditionalTextClass : "", " z-10 ").concat(removeTopMargin ? "mt-0" : "lg:mt-5 xl:mt-4", "  2xl:pr-10  "),
      children: LinkParagraph(showFullSpecification ? content : content.split(" ").slice(0, 50).join(" "))
    }), (content === null || content === void 0 ? void 0 : content.split(" ").length) > 70 && /*#__PURE__*/_jsx("button", {
      onClick: toggleSpecification,
      className: "text-primary text-base font-bold block",
      children: showFullSpecification ? "Read less" : "Read more"
    })]
  });
}
export default Description;